import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Icon from 'flarum/common/components/Icon';
const t = (key, params) => app.translator.trans('ppk2-profile.lib.agreement.' + key, params);
const LANG_NAMES = {
  ru: 'Русский',
  en: 'English',
  fi: 'Suomi',
  pl: 'Polski',
  uk: 'Українська',
  custom: null
};

/**
 * «Пользовательское соглашение» settings (admin extension page and /agreement-settings for
 * the group «Техподдержка»): switch «Включить соглашение при регистрации», mode «Свой текст» /
 * «Тема соглашения», the text or the topic, and the list of editions.
 * GET / POST /api/ppk2/agreement/settings.
 */
export default class AgreementSettings extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.data = null;
    this.form = null;
    this.errors = {};
    this.saving = false;
    this.openEdition = null;
    this.editionTexts = {};
    this.load();
  }
  apiUrl() {
    return app.forum.attribute('apiUrl') + '/ppk2/agreement/settings';
  }
  load() {
    app.request({
      method: 'GET',
      url: this.apiUrl()
    }).then(r => this.set(r.data));
  }
  set(data) {
    this.data = data;
    this.form = {
      enabled: !!data.enabled,
      mode: data.mode,
      text: data.text || '',
      topic: data.topic ? String(data.topic) : ''
    };
    m.redraw();
  }
  save() {
    this.saving = true;
    this.errors = {};
    app.request({
      method: 'POST',
      url: this.apiUrl(),
      body: this.form,
      errorHandler: e => {
        (e.response && e.response.errors || []).forEach(err => {
          const f = (err.source && err.source.pointer || '').split('/').pop() || 'form';
          this.errors[f] = err.detail;
        });
        if (!Object.keys(this.errors).length) this.errors.form = 'Error';
      }
    }).then(r => {
      this.set(r.data);
      app.alerts.show({
        type: 'success'
      }, t('saved'));
      app.forum.pushAttributes({
        ppk2AgreementActive: r.data.enabled && r.data.edition > 0
      });
    }, () => {}).finally(() => {
      this.saving = false;
      m.redraw();
    });
  }
  toggleEdition(n) {
    this.openEdition = this.openEdition === n ? null : n;
    if (this.openEdition && !this.editionTexts[n]) {
      app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/ppk2/agreement/editions/' + n
      }).then(r => {
        this.editionTexts[n] = r.data.texts;
        m.redraw();
      });
    }
  }
  error(name) {
    return this.errors[name] ? m("div", {
      className: "Ppk2AgreementSettings-error"
    }, m(Icon, {
      name: "fas fa-circle-xmark"
    }), " ", this.errors[name]) : null;
  }
  view() {
    if (!this.data) return m(LoadingIndicator, null);
    const f = this.form;
    const d = this.data;
    const langs = Object.keys(d.topicLangs || {});
    const date = iso => iso ? dayjs(iso).format('YYYY-MM-DD HH:mm') : '';
    return m("div", {
      className: "Ppk2AgreementSettings"
    }, m("div", {
      className: "Form-group"
    }, m(Switch, {
      state: f.enabled,
      onchange: v => f.enabled = v
    }, t('enabled')), m("div", {
      className: "helpText"
    }, t('enabled_tip')), !d.enabled ? m("div", {
      className: "helpText Ppk2AgreementSettings-off"
    }, t('inactive')) : null), m("div", {
      className: "Form-group"
    }, m("label", null, t('mode')), m("div", {
      className: "Ppk2AgreementSettings-modes",
      role: "radiogroup"
    }, ['custom', 'topic'].map(mode => m("label", {
      className: 'Ppk2AgreementSettings-mode' + (f.mode === mode ? ' is-active' : '')
    }, m("input", {
      type: "radio",
      name: "ppk2-agreement-mode",
      value: mode,
      checked: f.mode === mode,
      onchange: () => f.mode = mode
    }), t('mode_' + mode)))), m("div", {
      className: "helpText"
    }, t('mode_tip')), this.error('mode')), f.mode === 'custom' ? m("div", {
      className: "Form-group"
    }, m("label", {
      for: "ppk2-agreement-text"
    }, t('text')), m("textarea", {
      id: "ppk2-agreement-text",
      className: "FormControl Ppk2AgreementSettings-text",
      rows: "16",
      value: f.text,
      oninput: e => f.text = e.target.value
    }), m("div", {
      className: "helpText"
    }, t('text_tip')), this.error('text')) : m("div", {
      className: "Form-group"
    }, m("label", {
      for: "ppk2-agreement-topic"
    }, t('topic')), m("input", {
      id: "ppk2-agreement-topic",
      className: "FormControl Ppk2AgreementSettings-topic",
      type: "text",
      placeholder: t('topic_ph'),
      value: f.topic,
      oninput: e => f.topic = e.target.value
    }), m("div", {
      className: "helpText"
    }, t('topic_tip')), d.topic && String(d.topic) === f.topic ? m("div", {
      className: 'helpText Ppk2AgreementSettings-found' + (langs.length ? '' : ' is-empty')
    }, langs.length ? t('topic_found', {
      title: d.topicTitle || '#' + d.topic,
      langs: langs.map(l => LANG_NAMES[l] || l).join(', ')
    }) : t('topic_no_lang', {
      title: d.topicTitle || '#' + d.topic
    })) : null, this.error('topic')), m("div", {
      className: "Form-group"
    }, m("p", {
      className: "helpText"
    }, t('warn_reaccept')), this.error('form'), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-save",
      loading: this.saving,
      onclick: () => this.save()
    }, t('save'))), m("div", {
      className: "Form-group Ppk2AgreementSettings-editions"
    }, m("label", null, t('editions')), m("div", {
      className: "helpText"
    }, d.edition ? t('current_edition', {
      n: d.edition
    }) : t('no_edition')), m("ul", null, d.editions.map(e => m("li", null, m("b", null, t('edition_n', {
      n: e.edition
    })), " \xB7 ", date(e.createdAt), " \xB7 ", e.langs.map(l => l === 'custom' ? t('mode_custom') : l).join(', '), ' ', m(Button, {
      className: "Button Button--link",
      onclick: () => this.toggleEdition(e.edition)
    }, t('show_text')), this.openEdition === e.edition ? this.editionTexts[e.edition] ? Object.entries(this.editionTexts[e.edition]).map(([lang, text]) => m("pre", {
      className: "Ppk2AgreementSettings-source"
    }, m("b", null, lang === 'custom' ? t('mode_custom') : 'LANG=' + lang), '\n' + text)) : m(LoadingIndicator, {
      size: "small",
      display: "inline"
    }) : null)))));
  }
}
flarum.reg.add('ppk2-profile', 'common/AgreementSettings', AgreementSettings);